var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.newUserPop,"width":"30%","center":""},on:{"update:visible":function($event){_vm.newUserPop=$event}}},[_c('div',{staticClass:"newUserPop-box"},[_c('p',[_vm._v("新用户福利")]),_vm._v(" "),_c('p',[_vm._v("笔杆论文送你一天会员特权，可使用平台内所有会员功能，享受所有会员特权。"),_c('span',{on:{"click":_vm.goVip}},[_vm._v("查看会员特权")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b885d088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newUserPop.vue
// module id = 5o0b
// module chunks = 4